import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import Advertisement336 from './Ad_GA_336';
import { useAdsHidden } from '../../hooks/useAdsHidden';

interface AdSet {
  mainLink: string;
  mainImage: string;
  trackingImage?: string;
  width?: string;
  height?: string;
}

const AD_SETS: AdSet[] = [
  {
    // Amazon特典付き
    mainLink: "https://amzn.to/4fETcTb",
    mainImage: "/image/adv/amazon_special.jpg",
  },
  {
    // Amazon Music
    mainLink: "https://amzn.to/4jzPQCn",
    mainImage: "/image/adv/amazon_music.jpg",
  },
  {
    // DMMブックス
    mainLink: "https://px.a8.net/svt/ejp?a8mat=3ZK46T+FH9R02+6HW+3SZUAP",
    mainImage: "https://www26.a8.net/svt/bgt?aid=241123637936&wid=001&eno=01&mid=s00000000842023010000&mc=1",
    trackingImage: "https://www16.a8.net/0.gif?a8mat=3ZK46T+FH9R02+6HW+3SZUAP",
    width: "300",
    height: "250"
  },
  {
    // ABEMAプレミアム
    mainLink: "https://px.a8.net/svt/ejp?a8mat=3ZK46T+FD3QJE+4EKC+614CX",
    mainImage: "https://www27.a8.net/svt/bgt?aid=241123637929&wid=002&eno=01&mid=s00000020550001013000&mc=1",
    trackingImage: "https://www17.a8.net/0.gif?a8mat=3ZK46T+FD3QJE+4EKC+614CX",
    width: "300",
    height: "250"
  },
  {
    // GEOオンライン
    mainLink: "https://px.a8.net/svt/ejp?a8mat=3ZK4YT+2PN4RE+4J34+60OXD",
    mainImage: "https://www25.a8.net/svt/bgt?aid=241124645164&wid=002&eno=01&mid=s00000021136001011000&mc=1",
    trackingImage: "https://www15.a8.net/0.gif?a8mat=3ZK4YT+2PN4RE+4J34+60OXD",
    width: "300",
    height: "250"
  },
  {
    // ebook
    mainLink: "https://px.a8.net/svt/ejp?a8mat=3ZK4YT+5HNYE2+279M+70P81",
    mainImage: "https://www21.a8.net/svt/bgt?aid=241124645332&wid=002&eno=01&mid=s00000010273001179000&mc=1",
    trackingImage: "https://www15.a8.net/0.gif?a8mat=3ZK4YT+5HNYE2+279M+70P81",
    width: "300",
    height: "250"
  },
  {
    // ponta
    mainLink: "https://px.a8.net/svt/ejp?a8mat=3ZK4YT+6LJZX6+45QK+691UP",
    mainImage: "https://www20.a8.net/svt/bgt?aid=241124645399&wid=002&eno=01&mid=s00000019406001050000&mc=1",
    trackingImage: "https://www10.a8.net/0.gif?a8mat=3ZK4YT+6LJZX6+45QK+691UP",
    width: "300",
    height: "250"
  },
  {
    // Xserver
    mainLink: "https://px.a8.net/svt/ejp?a8mat=3ZK471+2A5V16+CO4+2NAN35",
    mainImage: "https://www23.a8.net/svt/bgt?aid=241123645138&wid=002&eno=01&mid=s00000001642016006000&mc=1",
    trackingImage: "https://www19.a8.net/0.gif?a8mat=3ZK471+2A5V16+CO4+2NAN35",
    width: "300",
    height: "250"
  },
  {
    // Hulu
    mainLink: "https://t.afi-b.com/visit.php?a=G8792C-j2987411&p=x941915Z",
    mainImage: "https://www.afi-b.com/upload_image/8792-1499465975-3.jpg",
    trackingImage: "https://t.afi-b.com/lead/G8792C/x941915Z/j2987411",
    width: "300",
    height: "250"
  }
];

const RectangleAdvertisement: React.FC = () => {
  const adsHidden = useAdsHidden();
  const shouldShowAdSense = useMemo(() => Math.random() < 0.5, []);
  const selectedAd = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * AD_SETS.length);
    return AD_SETS[randomIndex];
  }, []);

  if (adsHidden) return null;

  if (shouldShowAdSense) {
    return (
      <Box>
        <Advertisement336 />
      </Box>
    );
  }

  return (
    <Box 
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        bgcolor: 'rgba(255, 255, 255, 0.02)',
        borderRadius: 1,
        py: 2,
        px: 1.5,
        position: 'relative'
      }}
    >
      <Typography 
        variant="caption" 
        sx={{ 
          position: 'absolute',
          top: 8,
          right: 8,
          fontSize: '0.6rem',
          color: 'text.secondary',
          bgcolor: 'rgba(70, 70, 70, 0.75)',
          px: 0.8,
          py: 0.2,
          borderRadius: 0.5,
          letterSpacing: '0.05em',
          lineHeight: 1
        }}
      >
        PR
      </Typography>
      <Box 
        sx={{ 
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        <a 
          href={selectedAd.mainLink} 
          rel="nofollow noopener noreferrer" 
          target="_blank"
        >
          <img 
            style={{ 
              maxWidth: '100%', 
              height: 'auto',
              border: '0',
              display: 'block',
            }}
            width={selectedAd.width}
            height={selectedAd.height}
            alt="Advertisement" 
            src={selectedAd.mainImage}
          />
        </a>
      </Box>
      {selectedAd.trackingImage && (
        <img 
          style={{ border: '0' }}
          width="1" 
          height="1" 
          src={selectedAd.trackingImage} 
          alt="" 
        />
      )}
    </Box>
  );
};

export default RectangleAdvertisement;